// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lobby-status{display:flex;flex-direction:column;align-items:center;gap:var(--default-grid-baseline)}`, "",{"version":3,"sources":["webpack://./src/components/RightSidebar/LobbyStatus.vue"],"names":[],"mappings":"AACA,cACC,YAAA,CACA,qBAAA,CACA,kBAAA,CACA,gCAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
